<div class="demand-price-entry text-nowrap font-12">
    <strong class="demand-price-label">{{ 'Summe netto' | translate }}</strong>
    <strong>
        <display-currency [value]="price.netPrice" [currencyCode]="price.currency" />
    </strong>
</div>
@for (tax of price.tax; track tax) {
    <div class="demand-price-entry text-nowrap">
        <strong class="demand-price-label">
            {{ 'zzgl. \{\{value\}\}% MwSt.' | translate: { value: tax.rate } }}
        </strong>
        <strong>
            <display-currency [value]="tax.amount" [currencyCode]="price.currency" />
        </strong>
    </div>
}
<div class="demand-price-entry text-nowrap font-12">
    <strong class="demand-price-label">{{ 'Summe brutto' | translate }}</strong>
    <strong>
        <display-currency [value]="price.grossPrice" [currencyCode]="price.currency" />
    </strong>
</div>
